import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import TrackAndCollaborateContainer from '~/features/track-n-collaborate'
import en_track_n_collaborate from '../../../public/locales/en/track-and-collaborate.json'
import jp_track_n_collaborate from '../../../public/locales/ja/track-and-collaborate.json'
// import jsonLd from '../../../public/schema.json'

const TrackAndCollaboratePage: FC = () => {
  const { t } = useTranslation()

  return (
    <>
      {/* <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      /> */}
      <HeadMetaTags
        title={t('meta:ats_track_and_collaborate:meta_title')}
        description={t('meta:ats_track_and_collaborate:meta_description')}
      />
      <TrackAndCollaborateContainer />
    </>
  )
}

export default withTranslateProvider(TrackAndCollaboratePage, {
  en: { track_n_collaborate: en_track_n_collaborate },
  ja: { track_n_collaborate: jp_track_n_collaborate }
})
